import { Component, AfterViewInit, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { IonicPage, NavController, NavParams, App } from 'ionic-angular';
import { NavControllerService } from '../../providers/nav-controller/navControllerService';
import { TableDirective } from '../../directives/table-directive';
import { PaytronBackendService } from '../../providers/paytron-backend/paytron-backend.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Storage } from '../../../node_modules/@ionic/storage';
import { CardType } from '../../app/models/CardType';
import { ModalDirective } from 'ngx-bootstrap';
import { AlertsHolder } from '../../app/models/AlertsHolder';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'page-card-types',
  templateUrl: 'card-types.html',
})
export class CardTypesPage implements AfterViewInit, OnDestroy, OnInit {
  @ViewChild(TableDirective)
  private table: TableDirective;

  @ViewChild('cardTypeModal')
  private editCardTypeModal: ModalDirective;

  private pageName: string = 'page-card-types';
  private cardTypes: CardType[] = [];
  private currentCardType: CardType = new CardType();
  private navControllerService: NavControllerService;
  private alertsHolder: AlertsHolder;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private backendService: PaytronBackendService,
    private translate: TranslateService,
    private app: App,
    private storage: Storage
  ) {
    this.navControllerService = new NavControllerService(app, storage);
    this.alertsHolder = new AlertsHolder(translate);
  }

  ngOnInit(): void {
    this.table.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 12,
    };
  }

  ngAfterViewInit(): void {}

  ngOnDestroy(): void {}

  ionViewDidEnter() {
    this.getCardTypes();
  }

  private getCardTypes() {
    this.backendService.getCardTypes(null, true).subscribe(
      (data) => {
        this.cardTypes = data;
        this.table.refreshTable();
      },
      (err: HttpErrorResponse) => {}
    );
  }

  submitEditCardType(btnEvent: HTMLButtonElement) {
    btnEvent.disabled = true;
    this.backendService
      .editCardType(this.currentCardType)
      .subscribe(
        (data) => {
          this.table.refreshTable();
          this.alertsHolder.show('User successfully saved', 'success');
        },
        (err: HttpErrorResponse) => {}
      )
      .add(() => {
        this.closeModal();
        btnEvent.disabled = false;
      });
  }

  editCardType(cardType: CardType) {
    this.currentCardType = cardType;
    this.showEditCardTypeModal();
  }

  showEditCardTypeModal() {
    this.editCardTypeModal.show();
  }

  closeModal() {
    this.getCardTypes();
    this.editCardTypeModal.hide();
  }

  onSearchChange(searchString) {
    this.table.filterBySearchText(searchString);
  }

  showTaxRatesPage() {
    this.navControllerService.showTaxRatesPage();
  }

  showUnitsOfMeasurePage() {
    this.navControllerService.showUnitsOfMeasurePage();
  }
}



// WEBPACK FOOTER //
// ./src/pages/card-types/card-types.ts